export const DEFAUL_MARKER_PLACE_ICON = `${process.env.REACT_APP_WEB_URL}/questionmark.png`;
export const MARKER_PLACE_ICON_KDETOSAKRA = `${process.env.REACT_APP_WEB_URL}/guessedPlace.png`;
export const DEFAUL_MARKER_ICON = `${process.env.REACT_APP_WEB_URL}/marker.png`;
